import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/stores/auth-store';
import { useChurchStore } from '@/stores/church-store';
import { formatDateTime } from '@/utils/format';

export const SupportAccessBanner = () => {
  const { t } = useTranslation('auth');
  const supportAccess = useAuthStore((state) => state.user?.supportAccess);
  const signOut = useAuthStore((state) => state.signOut);
  const churchName = useChurchStore((state) => state.church?.name);

  if (!supportAccess) return null;

  return (
    <div className="flex flex-col gap-2 border-b border-warning/30 bg-warning/10 px-4 py-2 sm:flex-row sm:items-center sm:justify-between sm:px-6">
      <p className="text-body-sm text-fg">
        {t('supportAccess.banner', {
          church: churchName ?? t('supportAccess.thisChurch'),
          until: formatDateTime(supportAccess.expiresAt),
        })}
      </p>
      <Button type="button" variant="outline" size="sm" className="shrink-0 self-end sm:self-auto" onClick={() => void signOut()}>
        {t('supportAccess.end')}
      </Button>
    </div>
  );
};
